<template>
    <div class="__question" >
        <h2 class="__question-title" :style="{color: PrimaryColour}" v-html="question.title"></h2>
        <p class="__question-hint" v-if="question.information.length > 0" v-html="question.information"></p>
        <div class="__answer-list">
            <div class="__answer" :class="{'active': answer.title === question.answer, '__answer--number': question.type === 'number'}" :style="[answer.title === question.answer ? { borderColor: PrimaryColour } : { }]" v-for="(answer, index) in filteredAnswers" :key="index" @click="setAnswer(answer.title)">
                <img v-if="question.type === 'image'" :src="getImage(answer.image)" class="__answer-image" />
                <div class="__answer-title" style="color: #fff;" :class="{'__answer-title--number': question.type === 'number'}" :style="{ backgroundColor: PrimaryColour }">{{answer.title}}</div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SELECT_ANSWER } from "../store/actions.type";

export default {
  name: 'Question',
  props: {
    question: Object
  },
  computed: {
    ...mapGetters(["PrimaryColour", "Settings"]),
    filteredAnswers() {
      // Filter out lpg or oil option if company have toggled this off in settings
      if (this.question.number === 4) {
        return this.question.answers.filter((el, index, arr) => {
          if (el.title === 'LPG' && !this.Settings.IsLPG) 
            return false;
          else if (el.title === 'Oil' && !this.Settings.IsOil)
            return false;
          else
            return true;
        })
      } else {
        return this.question.answers;
      }
    }
  },
  methods:{
    getImage(img) {
      //return process.env.NODE_ENV === 'Production' ? 'https://sf.surefiresoftware.co.uk/surequote2/front/img/' + img + '.svg' : require('@/static/img/' + img + '.svg')
      return 'https://sf.surefiresoftware.co.uk/surequote2/front/img/' + img + '.svg'
    },
    setAnswer(answer) {
        this.$store.dispatch(SELECT_ANSWER, answer)
    }
  }  
}
</script>
